import './styles.scss'
import React from 'react'

import Sidemenu from 'components/Sidemenu'
import MainView from './MainView'

const Conversations = (props) => (
  <div className='animated fadeIn'>
    <div
      className='conversations'
      style={{
        gap: props.tabs.activeUser
          ? '10px'
          : null
      }}
    >
      <Sidemenu {...props} />
      <MainView />
    </div>
  </div>
)

export default Conversations
